import { useEffect, useRef, useState } from 'react';
import './cart-contribution-card.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { ModalConfirm } from '@/components/modal/modal.component';
import { useSelector } from 'react-redux';
import { properCase } from '@/utils/properCase';

const CartContributionCard = ({ cartItem, itemData, changeContribution, removeItem }) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    // what the player is typing; saved (and clamped to min/max) on blur or Enter
    const [ draftContribution, setDraftContribution ] = useState(cartItem?.cost ?? '');
    const approveRef = useRef();

    useEffect(() => {
        setDraftContribution(cartItem?.cost ?? '');
    }, [cartItem?.cost])

    function saveChangedContribution() {
        const newContribution = Math.round(Number(draftContribution));
        if (newContribution === cartItem.cost) return;
        changeContribution(newContribution, cartItem.id);
        // the parent may clamp the amount to the same value already in the cart,
        // which wouldn't trigger the effect above, so show the saved value now
        setDraftContribution(cartItem.cost);
    }

    function saveRemovedItem() {
        setConfirmMessage('Are you sure you want to remove this contribution from your shopping cart?')
        approveRef.current = () => {
            removeItem(cartItem.id);
        }
    }

    return (
        <div className={`cart-contribution-card g-list-item ${screenSize}`}>
            {
                (cartItem && itemData) &&
                <div className='cart-contribution-grid'>
                    <div className='card-icon'>
                        <ImageContainer src={itemData.icon} className='icon' preview={true} />
                    </div>
                    <div className='card-text'>
                        <div className='item-name'>{itemData.name}</div>
                        <div className='meta'>{properCase(itemData.opt_itemType)}</div>
                        {/* <div className='item-quantity'>Quantity: {cartItem.quantity}</div> */}
                        {/* <div className='item-price'>
                            Unit Price: 
                            
                            
                        </div> */}
                        <div className='item-quantity'>
                            <div className='field small'>
                                <label>Contribution Amount</label>
                                <div className='input-div'>
                                    <ImageContainer 
                                        src="/images/icons/coin.png" 
                                        className="coin-icon" 
                                    />
                                    <input 
                                        className='short-input'
                                        type='number'
                                        value={draftContribution}
                                        onChange={(e) => setDraftContribution(e.target.value)}
                                        onBlur={() => saveChangedContribution()}
                                        onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                    />
                                    <button 
                                        className='g-button text-only meta'
                                        onClick={() => saveRemovedItem()}    
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className='card-total'>
                        Total: 
                        <ImageContainer 
                            src="/images/icons/coin.png" 
                            className="coin-icon" 
                        />
                        <b>{(cartItem.quantity * cartItem.cost).toLocaleString()}</b>
                    </div>
                </div>
            }
            <ModalConfirm 
                show={confirmMessage} 
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current}
            />
        </div>
    )
}

export default CartContributionCard